{
  "optional": "(valgfritt)",
  "country": {
    "label": "Land"
  },
  "powerOfAttorneyFile": {
    "label": "Fullmaktsdokument",
    "description": "Last opp fullmaktsskjema på representant",
    "deleteFromServer": "Slett fil fra server"
  },
  "uploadPowerOfAttorneyLater": {
    "label": "Last opp fullmakt senere",
    "description": "For at en representant skal være gyldig, må det lastes opp et fullmaktsdokument"
  },
  "applicationDocument": {
    "label": "Søknadsdokument",
    "description": "Last opp innmeldingsskjema eller overdragelsesskjema"
  },
  "caseDocument": {
    "label": "Saksdokument",
    "description": "Last opp dokumentasjon knyttet til fjerning av partner"
  },
  "forestownerAssociation": {
    "label": "Skogeierlag",
    "description": "Velg skogeierlag knyttet til skogeier"
  },
  "shareholderAccountNumber": {
    "label": "Kontonummer",
    "description": "Eksempel: 1111 22 33334"
  },
  "shareholderSsn": {
    "label": "Fødselsnummer (11 siffer)",
    "description": "Fyll inn hele fødselsnummeret (11 siffer)"
  },
  "shareholderName": {
    "label": "Navn"
  },
  "uploadApplicationDocumentLater": {
    "label": "Last opp søknadsdokument senere",
    "description": "Du kan laste opp dokumentet senere"
  },
  "birthDate": {
    "label": "Fødselsdato",
    "description": "Eksempel: dd.mm.åååå"
  },
  "firstName": {
    "label": "Fornavn",
    "description": "Eksempel: Ola"
  },
  "city": {
    "label": "Sted",
    "description": "Eksempel: Oslo"
  },
  "postCode": {
    "label": "Postnummer",
    "description": "Eksempel: 0123"
  },
  "lastName": {
    "label": "Etternavn",
    "description": "Eksempel: Nordmann"
  },
  "email": {
    "label": "E-post",
    "description": "Eksempel: ola@nordmann.no"
  },
  "phone": {
    "label": "Telefonnummer",
    "description": "Eksempel: 91 23 45 67"
  },
  "address": {
    "label": "Gatenavn",
    "description": "Eksempel: Tømmergata"
  },
  "houseNumber": {
    "label": "Husnummer",
    "description": "Eksempel: 16C"
  },
  "organizationNumber": {
    "label": "Organisasjonsnummer",
    "description": "Skriv inn organisasjonsnummeret (9 siffer)",
    "noOrganizationNumber": "Skogeier har ikke et organisasjonsnummer"
  },
  "accountNumber": {
    "label": "Kontonummer (<i>valgfritt</i>)",
    "description": "Eksempel: 1111 22 33334"
  },
  "accountNumberOptionalLong": {
    "label": "Kontonummer (<i>valgfritt, kan legges til senere</i>)",
    "description": "Eksempel: 1111 22 33334"
  },
  "accountNumberRequired": {
    "label": "Kontonummer",
    "description": "Eksempel: 1111 22 33334"
  },
  "name": {
    "label": "Navn"
  },
  "organizationName": {
    "label": "Organisasjonsnavn"
  },
  "sameieName": {
    "label": "Sameiets navn"
  },
  "mailRecipient": {
    "label": "Mottaker"
  },
  "mustBeDocumented": {
    "label": "Må dokumenteres"
  }
}
